import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "title", "message"]

  show(title, message, confirmCallback) {
    this.titleTarget.textContent = title
    this.dialogTarget.setAttribute("aria-label", title)
    this.messageTarget.textContent = message
    this.pendingAction = confirmCallback
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  confirm() {
    this.pendingAction?.()
    this.close()
  }

  closed() {
    this.pendingAction = null
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
